import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectiuniProiecteComponent } from './sectiuni-proiecte.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddSectiuniProiecteComponent } from './add-sectiuni-proiecte/add-sectiuni-proiecte.component';
import { EditSectiuniProiecteComponent } from './edit-sectiuni-proiecte/edit-sectiuni-proiecte.component';

@NgModule({
    declarations: [
        SectiuniProiecteComponent,
        AddSectiuniProiecteComponent,
        EditSectiuniProiecteComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [SectiuniProiecteComponent],
})
export class SectiuniProiecteModule { }
